import React from 'react';

const BadgeButton = (
  {
    title,
    description,
    deal,
    width,
    selected,
    onClick,
    onRedirect,
    bgColor,
    margin,
    bgColorHover,
    textSize,
    textColor,
    descriptionFont,
    sm = false,
    lg = false,
  }) => {
  let sizingClasses = 'py-3 w-16 md:w-20 text-center'
  if (sm) {
    sizingClasses = 'py-3 px-3 lg:py-5 lg:px-5'
  }
  if (lg) {
    sizingClasses = 'py-3 px-3 md:px-5 md:py-5 md:w-64 lg:w-80 flex flex-col'
  }

  const className = `${selected ? ' border-2 border-primary' : ' border border-gray-300'} rounded-lg shadow-md align-center ${sizingClasses} ${bgColor ? bgColor : 'bg-white'}  ${bgColorHover ? bgColorHover : 'hover:bg-primary-30'} focus:outline-none ${width ? width : ''} ${margin ? margin : 'mr-2'} cursor-pointer`

  return (
    <div
      className={className} onClick={onClick}>
      {title && <div
        className={`'mt-1 ${textSize ? textSize : 'text-base md:text-xl lg:text-2xl'} ${textColor ? textColor : 'text-gray-800'} font-bold`}>{title}</div>}
      {description &&
      <div
        className={`text-sm lg:text-base text-gray-800 font-sans ${descriptionFont ? descriptionFont : "font-normal"}`}>{description}</div>}
      {deal &&
      <div onClick={onRedirect}
           className={`${onRedirect ? "hover:underline hover:text-gray-700" : ''} text-primary font-semibold font-sans text-sm md:text-base mb-1`}>{deal}</div>}
    </div>
  )
}

export default BadgeButton;
